"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_WITH_SECONDS_MIN_WIDTH = exports.INPUT_WITH_MS_MIN_WIDTH = void 0;
var INPUT_WITH_SECONDS_MIN_WIDTH = 235;
exports.INPUT_WITH_SECONDS_MIN_WIDTH = INPUT_WITH_SECONDS_MIN_WIDTH;
var INPUT_WITH_MS_MIN_WIDTH = INPUT_WITH_SECONDS_MIN_WIDTH + 25;
exports.INPUT_WITH_MS_MIN_WIDTH = INPUT_WITH_MS_MIN_WIDTH;